import React, { useReducer } from 'react';
import PropTypes from 'prop-types';
import { TextContext } from '@/utils/contexts/TextContext';

// context store elements
import initialState from '@/views/pages/Letter/letterContextStore/initialState';
import textWrapperDispatchMiddleware from '@/views/pages/Letter/letterContextStore/textWrapperDispatchMiddleware';
import textWrapperReducer from '@/views/pages/Letter/letterContextStore/textWrapperReducer';

const LetterContextWrapper = ({ children }) => {
	const [ contextState, contextDispatch ] = useReducer(textWrapperReducer, initialState);    
	return (
		<TextContext.Provider
			value={ {
				// using useReducer
				contextState,
				contextDispatch: textWrapperDispatchMiddleware(contextDispatch, contextState),
			} }
		>
			{children}
		</TextContext.Provider>
	);
};

LetterContextWrapper.propTypes = {
	children: PropTypes.oneOfType([ PropTypes.string, PropTypes.element ]),
};

export default LetterContextWrapper;